<!-- 高速公路养护 -->
<template>
    <div class="system-container">
        <div class="section">
            <div class="section-content">
                <div class="title">平台概述</div>
                <p class="text">
                    高速公路养护管理平台，以“可视化驾驶舱、基础数据管理、技术状况评定、养护决策分析、巡检养护、施工考核、计量支付、合同
                    及安全管理”为核心，实现了从基础数据管理、养护巡查、任务下达、施工验收、计量支付、考核评价等整个管理流程的科学化、信息化、
                    标准化。
                </p>

                <img class="image" src="@/assets/image/prescription/fun_model.png" alt/>
            </div>
        </div>


        <div class="section" style="background-color: #EAF3FF;">
            <div class="section-content">
                <div class="title">核心功能</div>
                <div class="core">
                    <div class="core-list">
                        <div class="core-item"
                             :class="{last:index === mobileCoreList.length -1}"
                             v-for="(item,index) in mobileCoreList"
                             :key="index"
                        >
                            <img class="mobile_image" :src="item.img" alt="">
                            <div class="mobile_label">{{ item.label }}</div>
                        </div>
                    </div>
                    <Carousel :images="images"></Carousel>
                </div>
                <!--移动端适配-->
                <div class="mobile-core">
                    <div class="core-list">
                        <div class="core-item"
                             :class="{last:index === mobileCoreList.length -1}"
                             v-for="(item,index) in mobileCoreList"
                             :key="index"
                        >
                            <img class="mobile_image" :src="item.img" alt="">
                            <div class="mobile_label">{{ item.label }}</div>
                        </div>
                    </div>
                    <el-carousel class="carousel" height="200px" trigger="click">
                        <el-carousel-item v-for="(item,index) in images" :key="index">
                            <img
                                :src="item"
                                style="width: 100%;height: 100%;
                            object-fit: scale-down"
                                alt
                            />
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>


        </div>
        <div class="section">
            <div class="section-content">
                <div class="title">应用价值</div>
                <div class="panel-content">
                    <div class="panel" v-for="(item,index) in panelList" :key="index">
                        <img class="image" :src="item.icon" style="width: 3.75rem;height: 3.75rem;" alt/>
                        <div>
                            <div class="label">{{ item.label }}</div>
                            <p class="info">{{ item.text }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//components
import Carousel from '@/components/Carousel'

export default {
    components: {
        Carousel
    },
    name: 'freewayMaintain',
    data() {
        return {
            images: [
                require('@/assets/image/prescription/sys_7.png'),
                require('@/assets/image/prescription/sys_8.png'),
            ],
            panelList: [
                {
                    icon: require('@/assets/image/prescription/icon_17.png'),
                    label: '建立了标准的基础数据库',
                    text: '路线、桥梁、涵洞、隧道、交安、防护、排水等公路设施基本信息集中管理，所有基础数据一目了然便于统计和管理，建立了标准规范的公路设施数据库。'
                },
                {
                    icon: require('@/assets/image/prescription/icon_18.png'),
                    label: '建立了标准的管养业务体系',
                    text: '通过系统应用结合实际养护需求，重塑了业务流程，建立了标准化的养护体系，从养护巡查到养护任务下达、实施情况上报到初步验收、计量支付，实现了流程标准化，养护精细化，决策科学化。'
                },
                {
                    icon: require('@/assets/image/prescription/icon_19.png'),
                    label: '巡查作业人员实时动态监管',
                    text: '通过GPS定位数据，可实时通过“一张图”上显示人员地理位置信息，轨迹实时查询、回放一目了然、有迹可循，有效地提高了管理单位的监管力度。'
                }
            ],
            mobileCoreList: [
                {label: '大数据可视化驾驶舱', img: require('@/assets/image/prescription/icon_1_small.png')},
                {label: '综合业务工作台', img: require('@/assets/image/prescription/icon_2_small.png')},
                {label: '路产路权', img: require('@/assets/image/prescription/icon_3_small.png')},
                {label: '巡查养护', img: require('@/assets/image/prescription/icon_4_small.png')},
                {label: '施工验收', img: require('@/assets/image/prescription/icon_5_small.png')},
                {label: '计量支付', img: require('@/assets/image/prescription/icon_6_small.png')},
                {label: '合同资料', img: require('@/assets/image/prescription/icon_7_small.png')},
                {label: '车辆管理', img: require('@/assets/image/prescription/icon_8_small.png')},
                {label: '员工学习', img: require('@/assets/image/prescription/icon_9_small.png')},
                {label: '统计分析', img: require('@/assets/image/prescription/icon_10_small.png')},

            ]
        }
    },
    methods: {
        //切换图片
        toggleImage(type) {
            this.$refs.carousel[type]()
        }
    },
}
</script>

<style lang='scss' scoped>
.system-container {
    height: 100%;
    width: 100%;

    .section {
        height: 100%;
        width: 100%;

        .section-content {
            margin: 0 auto;
            width: 1200px;
            padding: 50px 0;
            text-align: center;

            .title {
                text-align: center;
                font-size: 32px;
            }

            .text {
                margin-top: 40px;
                text-indent: 2em;
                line-height: 32px;
                font-size: 20px;
                text-align: justify;
            }

            .image {
                margin-top: 60px;
                width: 1020px;
            }
        }
    }

    .panel-content {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;

        .panel {
            box-sizing: border-box;
            width: calc(100% / 3 - 16px);
            padding: 30px;
            box-shadow: 0 3px 18px 1px rgba(26, 102, 187, 0.14);

            .label {
                padding: 30px 0;
                font-size: 24px;
                font-weight: bold;
            }

            .info {
                width: 300px;
                line-height: 32px;
                font-size: 20px;
                text-align: justify;
            }
        }
    }

    .mobile-core {
        display: none;
    }

    .core {
        .core-list {
            margin-top: 24px;
            font-size: 20px;
            display: grid;
            grid-template-columns: repeat(5, 1fr);
            grid-template-rows: repeat(2, 1fr);
            grid-gap: 24px;

            .core-item {
                background-color: #FFFFFF;
                border-radius: 4px;
                padding: 20px;

                .mobile_image {
                    width: 60px;
                    height: 60px;
                }

                .mobile_label {
                    line-height: 30px;
                }
            }
        }
    }
}

@import "./style.scss";
</style>
